var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"alert triangle\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6662 2.32546L1.5826 17.4899C1.39532 17.8142 1.29622 18.1819 1.29517 18.5564C1.29413 18.931 1.39116 19.2992 1.57662 19.6246C1.76209 19.95 2.02952 20.2211 2.35231 20.4111C2.67509 20.601 3.04199 20.7031 3.41649 20.7072H21.5837C21.9582 20.7031 22.3251 20.601 22.6479 20.4111C22.9707 20.2211 23.2381 19.95 23.4236 19.6246C23.6091 19.2992 23.7061 18.931 23.7051 18.5564C23.704 18.1819 23.6049 17.8142 23.4176 17.4899L14.334 2.32546C14.1428 2.01028 13.8736 1.74968 13.5524 1.56883C13.2312 1.38798 12.8688 1.29297 12.5001 1.29297C12.1315 1.29297 11.7691 1.38798 11.4478 1.56883C11.1266 1.74968 10.8574 2.01028 10.6662 2.32546Z",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 7.83789V12.1277",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 16.4175H12.5121",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8890539fa621b4d1586757c7958d447c.svg";
export { ForwardRef as ReactComponent };